import React from 'react'
import { HeaderGroup } from 'react-table'
import { ExtendableStyles } from 'utils-next/types'

import { TableHead as TableHeaderInternal } from '@mui/material'

import { TableHeaderGroup } from './TableHeaderGroup.component'

export type TableHeaderProps<DataType extends object> = ExtendableStyles & {
  headerGroups: HeaderGroup<DataType>[]
}

export function TableHeader<DataType extends object>({
  className,
  style,
  headerGroups,
  ...otherProps
}: TableHeaderProps<DataType>) {
  return (
    <TableHeaderInternal className={className} style={style} {...otherProps}>
      {headerGroups.map(({ getHeaderGroupProps, ...props }, index) => (
        <TableHeaderGroup {...getHeaderGroupProps()} {...props} key={props.id || `t-header-group-${index}`} />
      ))}
    </TableHeaderInternal>
  )
}
